import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Sarah M.',
  text: 'Das beste Studio in Nürnberg! Die Atmosphäre ist einzigartig und die Trainerinnen sind super kompetent.'
}, {
  id: 2,
  name: 'Lisa K.',
  text: 'Seit ich hier trainiere, bin ich so viel flexibler geworden. Aerial Stretching hat mein Leben verändert!'
}, {
  id: 3,
  name: 'Maria T.',
  text: 'Endlich ein Studio nur für Frauen! Ich fühle mich hier so wohl und motiviert.'
}, {
  id: 4,
  name: 'Jana R.',
  text: 'Die kleinen Gruppen sind perfekt. Man bekommt wirklich individuelle Betreuung.'
}, {
  id: 5,
  name: 'Petra W.',
  text: 'Personal Training hier hat mir geholfen, meine Rückenschmerzen loszuwerden. Danke!'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section className="py-24 bg-peony-50 relative overflow-hidden" data-id="element-215">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-peony-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-216"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000" data-id="element-217"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-218">
        <h2 className="text-3xl md:text-4xl font-bold text-dark-studio mb-12" data-id="element-219">
          Was unsere Kundinnen sagen
        </h2>

        <div className="relative h-64 sm:h-48" data-id="element-220">
          {testimonials.map((item, index) => <div key={item.id} className={`absolute inset-0 transition-all duration-700 ease-in-out transform ${index === currentIndex ? 'opacity-100 translate-x-0 scale-100' : 'opacity-0 translate-x-8 scale-95 pointer-events-none'}`} data-id="element-221">
              <div className="bg-white/60 backdrop-blur-md p-8 rounded-2xl shadow-xl border border-white/50 max-w-2xl mx-auto" data-id="element-222">
                <div className="flex justify-center space-x-1 mb-4 text-peony-500" data-id="element-223">
                  {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-224" />)}
                </div>
                <p className="text-xl text-gray-700 italic mb-6 leading-relaxed" data-id="element-225">
                  "{item.text}"
                </p>
                <p className="font-bold text-dark-studio uppercase tracking-wider text-sm" data-id="element-226">
                  - {item.name}
                </p>
              </div>
            </div>)}
        </div>

        {/* Dots Navigation */}
        <div className="flex justify-center space-x-2 mt-8" data-id="element-227">
          {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-peony-600 w-8' : 'bg-peony-200 hover:bg-peony-400'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-228" />)}
        </div>
      </div>
    </section>;
}